import { render, staticRenderFns } from "./ProductListTable.vue?vue&type=template&id=0c5d896c&scoped=true&lang=html&"
import script from "./ProductListTable.vue?vue&type=script&lang=js&"
export * from "./ProductListTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductListTable.vue?vue&type=style&index=0&id=0c5d896c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5d896c",
  null
  
)

export default component.exports